import { Link } from "react-router-dom";
import { BookOpen, Heart } from "lucide-react";
import { PetalsCanvas } from "./PetalsCanvas";
import { BOOK_TITLE } from "../data/bookData";

export const Hero = () => (
  <section data-testid="hero-section" className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-6 text-center">
    <PetalsCanvas />
    <div className="pointer-events-none absolute -left-32 top-16 h-80 w-80 rounded-full bg-[#E6E1F4]/60 blur-3xl" />
    <div className="pointer-events-none absolute -right-24 bottom-24 h-96 w-96 rounded-full bg-[#FAE3E8]/80 blur-3xl" />

    <div className="relative z-10 max-w-3xl">
      <p className="rise-in font-hand text-2xl text-[#C87D87] sm:text-3xl" style={{ animationDelay: "0.1s" }}>
        a little something i made
      </p>
      <h1
        className="rise-in mt-6 font-display text-4xl font-semibold leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl"
        style={{ animationDelay: "0.25s" }}
        data-testid="hero-title"
      >
        {BOOK_TITLE.split(" and ")[0]} and <em className="text-[#C87D87]">i</em>
      </h1>
      <p className="rise-in mt-4 font-hand text-xl text-[#4A2E35]/70 sm:text-2xl" style={{ animationDelay: "0.32s" }}>
        happy birthday, auntie
      </p>
      <p className="rise-in mx-auto mt-5 max-w-xl text-sm leading-relaxed text-[#4A2E35]/70 sm:text-base" style={{ animationDelay: "0.4s" }}>
        Hope you enjoy!
      </p>
      <div className="rise-in mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row" style={{ animationDelay: "0.55s" }}>
        <Link
          to="/read"
        data-testid="hero-open-book-btn"
          className="group inline-flex items-center gap-2.5 rounded-full bg-[#C87D87] px-8 py-4 text-sm font-semibold text-[#FFFDF9] shadow-lg shadow-[#C87D87]/30 transition-all hover:-translate-y-0.5 hover:bg-[#B86B76] hover:shadow-xl active:translate-y-0"
        >
          <BookOpen size={18} className="transition-transform group-hover:rotate-[-8deg]" />
          Open the Book
        </Link>
        <a
          href="#dedication"
          data-testid="hero-letter-btn"
          className="inline-flex items-center gap-2 rounded-full border border-[#E8B4B8] bg-[#FFFDF9]/70 px-8 py-4 text-sm font-semibold text-[#4A2E35] backdrop-blur transition-all hover:-translate-y-0.5 hover:bg-[#FFFDF9]"
        >
          <Heart size={16} className="text-[#C87D87]" />
          Read the Preface First
        </a>
      </div>
    </div>
  </section>
);
